import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth.jsx";
import Layout from "@/components/Layout.jsx";
import Login from "@/pages/Login.jsx";
import Dashboard from "@/pages/Dashboard.jsx";
import Listing from "@/pages/Listing.jsx";
import Favorites from "@/pages/Favorites.jsx";
import AdminUsers from "@/pages/AdminUsers.jsx";
import AdminSystem from "@/pages/AdminSystem.jsx";
import ChangePassword from "@/pages/ChangePassword.jsx";
import StockDetail from "@/pages/StockDetail.jsx";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm">
        Carregando…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (user.must_change_password && location.pathname !== "/conta/senha") {
    return <Navigate to="/conta/senha?force=1" replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicOnly>
                <Login />
              </PublicOnly>
            }
          />
          <Route
            path="/conta/senha"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="/listagem" element={<Listing />} />
            <Route path="/favoritos" element={<Favorites />} />
            <Route path="/acao/:stockId" element={<StockDetail />} />
            <Route
              path="/admin/usuarios"
              element={
                <ProtectedRoute adminOnly>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/sistema"
              element={
                <ProtectedRoute adminOnly>
                  <AdminSystem />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
